import React from 'react';

import Button, { ButtonProps } from '../Button';
import DialogHandler from '../DialogHandler';

type Props = {
  renderDialog: ({ isOpen, closeDialog }: { isOpen: boolean; closeDialog: () => void }) => React.ReactNode;
  defaultOpen?: boolean;
} & ButtonProps;

const DialogButton = ({ renderDialog, onClick, defaultOpen, ...props }: Props) => (
  <DialogHandler renderDialog={renderDialog} onClick={onClick} defaultOpen={defaultOpen}>
    <Button {...props} />
  </DialogHandler>
);

export default DialogButton;
